export default __webpack_public_path__ + "static/media/image5.e278ebe8.png";